<template>
  <div>
    <Head title="Familias de Productos" />
    <h1 class="mb-8 text-3xl font-bold">Familias</h1>
    <div class="flex items-center justify-between mb-6">
      <search v-model="form.search" class="mr-4 w-full max-w-md" @reset="reset">        
      </search>
      <Link class="btn-sky" href="/settings/products/families/create">
        <span>Crear</span>
        <span class="hidden md:inline">&nbsp;Familia</span>
      </Link>
    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="pb-4 pt-6 px-2">Descripción</th>
          <th class="pb-4 pt-6 px-2">Usuario</th>
          <th class="pb-4 pt-6 px-2">Fecha de creación</th>
        </tr>
        <tr v-for="family in productsFamilies.data" :key="family.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
          <td class="border-t">
            <Link class="flex items-center px-6 py-4" :href="`/settings/products/families/${family.id}/edit`">{{ family.descripcion }}</Link> 
          </td>
          <td class="border-t">
            <Link class="flex items-center px-6 py-4" :href="`/settings/products/families/${family.id}/edit`">{{ family.user }}</Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-6 py-4" :href="`/settings/products/families/${family.id}/edit`">{{ family.fecha }}</Link>
          </td>
          <td class="w-px border-t">
            <Link class="flex items-center px-6 py-4" :href="`/settings/products/families/${family.id}/edit`" tabindex="-1">
              <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
            </Link>
          </td>
        </tr>
        <tr v-if="productsFamilies.data.length === 0">
          <td class="px-6 py-4 border-t" colspan="3">No se encontraron familias de productos</td>
        </tr>
      </table>
    </div>
    <pagination class="mt-6" :links="productsFamilies.links" />
  </div>
</template>
<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import mapValues from 'lodash/mapValues'
import pickBy from 'lodash/pickBy'
import Search from '@/Shared/Search'
import throttle from 'lodash/throttle'
import Pagination from '@/Shared/Pagination'
import Icon from '@/Shared/Icon'
  
export default {
  components: {
    Head,
    Link,    
    Search,
    Pagination,
    Icon,
  },
  layout: Layout,
  props: {
    filters: Object,
    productsFamilies: Object,    
  },
  data() {
    return {
      form: {
        search: this.filters.search,        
      },
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get('/settings/products/families', pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
  },
}
</script>